/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CiBlock } from './CiBlock';

/**
 * One row of the pre-registered segment-library harm scan
 * (EVALUATION_METHODOLOGY.md amendment 7, `evaluation.replay.segments`):
 * the chosen config's per-segment Δ over the dev split, employer-
 * clustered. Deliberately a DIFFERENT concept from `ChannelReport.segments`
 * (`SegmentCell`, the legacy §4.5 per-perspective match cells) — hence
 * this type lives under `RunReport.harm_scan`, not `.segments`.
 */
export type SegmentResult = {
  segment_id: string;
  label: string;
  n: number;
  n_employers: number;
  delta: CiBlock;
  power_flag: SegmentResult.power_flag;
};
export namespace SegmentResult {
  export enum power_flag {
    OK = 'ok',
    UNDERPOWERED = 'underpowered',
    FEW_EMPLOYERS = 'few_employers',
  }
}
